export default "__VITE_ASSET__oD6sZHP8__"